import React from 'react';
import { SurveyType } from '../../../../../shared/constants';
import type { SurveyInsightsGranularity } from '../../../../../store/hubOwner/types';
import type { SurveyStats } from './surveyInsights';
import { buildStatCards, StatCardsStatus } from './surveyStatCards';
import StatCardsGrid from './StatCardsGrid';

interface SurveyStatsCardsProps {
  stats: SurveyStats;
  surveyType: SurveyType;
  // Window label for the "in window" tiles, e.g. 'Last 30 days'.
  windowLabel: string;
  // Trend bucket size, for the "needs N answered days/weeks" hint.
  granularity?: SurveyInsightsGranularity | null;
  // 'loading': window tiles show a placeholder; 'unavailable': N/A. Neither
  // ever shows zeros for a window that has not been fetched.
  status?: StatCardsStatus;
  // Same for the latest tile, which follows the response rows fetch.
  rowsStatus?: StatCardsStatus;
}

// Summary tiles above the trend chart for one patient.
const SurveyStatsCards: React.FC<SurveyStatsCardsProps> = ({
  stats,
  surveyType,
  windowLabel,
  granularity,
  status = 'ready',
  rowsStatus = 'ready',
}) => (
  <StatCardsGrid
    cards={buildStatCards(
      stats,
      surveyType,
      windowLabel,
      granularity,
      status,
      rowsStatus,
    )}
  />
);

export default SurveyStatsCards;
